<!--直播课-->
<template>
    <div class="el-LiveClass">
        <el-row class="page_content">
            <h1 class="head_title">直播课</h1>
            <p style="min-height: 100px;">

            </p>
            <h1 class="head_title" style="margin-top:20px;">选课结果</h1>
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column
                    prop="xq"
                    header-align="center"
                    align="center"
                    label="年级">
                </el-table-column>
                <el-table-column
                prop="address"
                header-align="center"
                align="center"
                label="直播名称">
                </el-table-column>
                <el-table-column
                prop="address"
                header-align="center"
                align="center"
                label="直播教师"
                width="180">
                </el-table-column>
                <el-table-column
                prop="address"
                header-align="center"
                align="center"
                label="直播开始时间"
                width="180">
                </el-table-column>
                <el-table-column
                prop="address"
                header-align="center"
                align="center"
                label="直播结束时间"
                width="180">
                </el-table-column>
                <el-table-column
                prop="address"
                header-align="center"
                align="center"
                label="房间号"
                width="180">
                <template slot-scope="scope">
                    <el-link :underline="false" type="danger">{{scope.row.xq}}</el-link>
                </template>
                </el-table-column>
                <el-table-column
                prop="address"
                header-align="center"
                align="center"
                label="操作"
                width="180">
                    <template slot-scope="scope">
                        <el-link :underline="false" type="primary" @click="retreatCourse(scope.$index)">观看直播</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
export default {
  name: "LiveClass",
  data() {
    return {
      tableData: [],
    };
  },
  created() {

  },
  methods: {
    retreatCourse(index){
        this.tableData[index];
        console.log(index);
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-LiveClass{
    .wd{
        color: @red;
    }
    .el-dialog__body{
        border-top:1px solid #ebeef5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/LiveClass.vue